<template>
  <base-slide-over ref="slideOver" :title="user ? user.email : ''">
    <div v-if="isLoadingLogs">
      <div class="tw-py-2.5 tw-px-6 tw-border-b" v-for="i in 3" :key="i">
        <base-skeleton-loader class="tw-h-3 tw-w-48 tw-mt-1.5" />
        <base-skeleton-loader class="tw-h-2 tw-w-28 tw-mt-3 tw-mb-1.5" />
      </div>
    </div>
    <div v-else-if="orderedEmailLogs.length">
      <div
        v-for="emailLog in orderedEmailLogs"
        :key="emailLog.contentLink"
        class="tw-py-2.5 tw-px-6 tw-border-b tw-cursor-pointer hover:tw-bg-gray-100 tw-transition-colors tw-duration-100"
        @click="getEmail(emailLog)"
      >
        {{ emailLog.templateName }}
        <div class="tw-text-sm tw-text-gray-500">{{ formatDate(emailLog.sentDate) }}</div>
      </div>
    </div>
    <div v-else>
      <div class="tw-text-gray-600 tw-flex tw-justify-center tw-py-5">
        No results
      </div>
    </div>
    <base-modal ref="modal" size="2xl">
      <base-card>
        <div v-if="isLoadingEmailContent" class="tw-flex tw-justify-center tw-py-5">
          <base-spinner />
        </div>
        <div v-html="emailContent" v-else />
      </base-card>
    </base-modal>
  </base-slide-over>
</template>

<script>
import { orderBy } from "lodash";
import moment from "moment";

export default {
  data() {
    return {
      isLoadingLogs: false,
      isLoadingEmailContent: false,
      user: null,
      emailLogs: [],
      emailContent: "",
    };
  },
  computed: {
    orderedEmailLogs() {
      return orderBy(this.emailLogs, ["sentDate"], ["desc"]);
    },
  },
  methods: {
    show(user) {
      this.user = user;
      this.$refs.slideOver.show();
    },
    async getEmailLogs() {
      if (!this.user) return;
      try {
        this.isLoadingLogs = true;
        const response = await this.$axios.get(`/users/${this.user.id}/sent-emails`);
        this.emailLogs = response.data.emailLogs;
      } finally {
        this.isLoadingLogs = false;
      }
    },
    formatDate(date) {
      return moment
        .utc(date)
        .local()
        .format("MMMM Do, YYYY h:mm A");
    },
    async getEmail(emailLog) {
      try {
        this.isLoadingEmailContent = true;
        this.$refs.modal.show();
        const documentResponse = await this.$axios.get(`/users/${this.user.id}/email-content?contentLink=${emailLog.contentLink}`);
        const downloadResponse = await this.$axios.get(documentResponse.data.downloadUrl);
        this.emailContent = downloadResponse.data;
      } finally {
        this.isLoadingEmailContent = false;
      }
    },
  },
  watch: {
    user() {
      this.getEmailLogs();
    },
  },
};
</script>
